import React from 'react';
import { Box, Button, Chip, Grid, InputLabel, OutlinedInput, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DefaultPreviewPdfFile from '../../../components/default-preview-pdf-file';
import PageHeader from '../../../components/page-header';
import { formatDate, formatDateTime } from '../../../utils/date';
import { useOfficialDiaryDetailController } from './context/official-diary-detail-controller';
import { useOfficialDiaryDetailState } from './context/official-diary-detail-context';

export function OfficialDiaryDetailComponent() {
    const { navigateBack } = useOfficialDiaryDetailController();
    const { officialDiaryDetail, officialDiaryFile } = useOfficialDiaryDetailState();

    const loaded = officialDiaryDetail?.id !== undefined;
    const subtitle = loaded
        ? [`Edição ${officialDiaryDetail.editionNumber}/${officialDiaryDetail.yearPublication}`, formatDate(officialDiaryDetail.publicationDate)].filter(Boolean).join(' - ')
        : undefined;
    const descriptions = Array.isArray(officialDiaryDetail?.descriptions)
        ? officialDiaryDetail.descriptions.join('\n')
        : officialDiaryDetail?.descriptions ?? '';

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Detalhes da edição"
                    subtitle={subtitle}
                    breadcrumbs={[
                        { label: 'Diário Oficial', href: '/diario-oficial' },
                        { label: 'Detalhes' }
                    ]}
                    actions={<Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={navigateBack}>Voltar</Button>}
                />
            </Grid>

            <Grid item xs={12} md={7}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <DefaultPreviewPdfFile props={{ file: officialDiaryFile }} />
                </Paper>
            </Grid>
            <Grid item xs={12} md={5}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                {loaded && (
                                    <React.Fragment>
                                        <Chip size="small" label={officialDiaryDetail.isClosed ? 'Fechada' : 'Aberta'} color={officialDiaryDetail.isClosed ? 'success' : 'default'} variant={officialDiaryDetail.isClosed ? 'filled' : 'outlined'} />
                                        <Chip size="small" label={officialDiaryDetail.isVisibility ? 'Visível' : 'Invisível'} color={officialDiaryDetail.isVisibility ? 'info' : 'default'} variant={officialDiaryDetail.isVisibility ? 'filled' : 'outlined'} />
                                    </React.Fragment>
                                )}
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <InputLabel>Nº edição</InputLabel>
                            <OutlinedInput disabled value={officialDiaryDetail?.editionNumber ?? ''} fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <InputLabel>Ano</InputLabel>
                            <OutlinedInput disabled value={officialDiaryDetail?.yearPublication ?? ''} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Data da edição</InputLabel>
                            <OutlinedInput disabled value={formatDate(officialDiaryDetail?.publicationDate)} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Fechada em</InputLabel>
                            <OutlinedInput disabled value={formatDateTime(officialDiaryDetail?.closedOn)} fullWidth />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputLabel>Fechada por</InputLabel>
                            <OutlinedInput disabled value={officialDiaryDetail?.closedByUser ?? ''} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel>Entidade</InputLabel>
                            <OutlinedInput disabled value={officialDiaryDetail?.clientName ?? ''} fullWidth />
                        </Grid>
                        <Grid item xs={12}>
                            <InputLabel>Descrição</InputLabel>
                            <OutlinedInput disabled multiline rows={15} value={descriptions} fullWidth />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
